import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { CloseOverlayService } from '../../_services/closeOverlay.service';
import { UserPermissionsPage } from '../user-permissions/user-permissions.page';


@Component({
  selector: 'app-add-manager',
  templateUrl: './add-manager.page.html',
  styleUrls: ['./add-manager.page.scss'],
})
export class AddManagerPage implements OnInit {
  subscription: any;
  managerName: any;
  phone: any;
  email: any;
  disabled = false;
  hideSpinner = true;

  constructor(
    private modalController: ModalController, private platform: Platform,
    private location: Location, private closeOverlayService: CloseOverlayService) { }

  async userPermissions() {
    const modal = await this.modalController.create({
      component: UserPermissionsPage,
      cssClass: 'user-permissions',
      showBackdrop: true,
      backdropDismiss: true,
    });
    return await modal.present();
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      if (this.constructor.name === 'AddManagerPage') {
        this.closeOverlayService.trigger();
      } else {
        this.location.back();
      }
    });
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
  }

}
